// extracted by css-extract-rspack-plugin
export default {"subscription-tier":"QPyfpd","subscriptionTier":"QPyfpd","total-spent":"xK68wh","totalSpent":"xK68wh"};